import moment from 'moment';

import {
    GROUPING_HOURLY,
    GROUPING_MONTHLY,
    GROUPING_WEEKLY,
} from './filters';

const DAY_LABEL_FORMAT = 'D MMM';
const DAYS_PER_WEEK = 7;

const METRICS = ['widgetLoads', 'conversations'];

const emptyBucket = () => ({ dates: [], widgetLoads: 0, conversations: 0 });

const addToBucket = (bucket, entry) =>
    METRICS.reduce(
        (accumulator, metric) =>
            Object.assign(accumulator, {
                [metric]: accumulator[metric] + (Number(entry[metric]) || 0),
            }),
        Object.assign({}, bucket, { dates: bucket.dates.concat(entry.date) }),
    );

const groupByWeek = (series) =>
    series.reduce((weeks, entry, index) => {
        const weekIndex = Math.floor(index / DAYS_PER_WEEK);
        weeks[weekIndex] = addToBucket(weeks[weekIndex] || emptyBucket(), entry);
        return weeks;
    }, []);

const groupByMonth = (series) => {
    const months = series.reduce((accumulator, entry) => {
        const monthKey = moment(entry.date).format('YYYY-MM');
        accumulator[monthKey] = addToBucket(
            accumulator[monthKey] || emptyBucket(),
            entry,
        );
        return accumulator;
    }, {});

    return Object.keys(months)
        .sort()
        .map((monthKey) => months[monthKey]);
};

const groupSeries = (series, grouping) => {
    if (grouping === GROUPING_WEEKLY) {
        return groupByWeek(series);
    }

    if (grouping === GROUPING_MONTHLY) {
        return groupByMonth(series);
    }

    return series.map((entry) => addToBucket(emptyBucket(), entry));
};

export const bucketLabel = (dates, grouping) => {
    if (grouping === GROUPING_HOURLY) {
        return moment(dates[0]).format('HH:00');
    }

    const first = moment(dates[0]).format(DAY_LABEL_FORMAT);

    if (dates.length < 2) {
        return first;
    }

    return `${first} - ${moment(dates[dates.length - 1]).format(DAY_LABEL_FORMAT)}`;
};

export const buildChartRows = (series = [], grouping) =>
    groupSeries(series, grouping).map((bucket) => ({
        label: bucketLabel(bucket.dates, grouping),
        widgetLoads: bucket.widgetLoads,
        conversations: bucket.conversations,
    }));

export default buildChartRows;
